module.exports = require("./vun.d.ts");